// Polished pre-made sample deck for the public /lpg-demo showcase (fictional luxury listing).
export const SAMPLE_DECK = {
  address: "18 Coral Reef Court, Naples, FL 34103",
  _source: { verified: true, provider: "sample", avm_price: 4250000,
    note: "Illustrative sample — every figure in a real presentation is grounded on the property you enter." },
  property: {
    headline: "Waterfront Contemporary in Park Shore, Steps to the Gulf",
    beds: 5, baths: 6, sqft: 6120, year_built: 2019, garage: "3-car attached",
    lot_acres: 0.42, hoa: "None", subdivision: "Park Shore", submarket: "Coastal Naples",
    neighborhood: "Park Shore",
  },
  executive_summary: {
    recommended_price: 4295000, price_low: 4150000, price_high: 4495000,
    price_per_sqft: 702, days_to_offer: "14–21 days", list_to_sale_ratio: "97.8%",
    market_temp: "Seller-leaning", headline: "Priced to command the coastal luxury tier",
    bullets: [
      { title: "Scarcity", text: "Only 6 comparable new-build waterfront homes sold in Park Shore in the last 12 months." },
      { title: "Momentum", text: "Median $/sqft up 8.4% year-over-year in the 34103 coastal core." },
      { title: "Buyer pool", text: "63% of luxury Naples closings are cash — low rate sensitivity at this tier." },
    ],
  },
  market: {
    window: "Trailing 12 months · Park Shore 34103", median_sold_price: "$3.95M", median_yoy: "+6.2%",
    median_ppsf: "$684", ppsf_yoy: "+8.4%", median_dom: "38 days", list_to_sale: "97.8%",
    active_listings: "22", months_supply: "4.1 mo", cash_buyers: "63%", appreciation_3yr: "+41%",
    temperature: "Seller-leaning",
  },
  price_trend: {
    title: "Park Shore median sale price", points: [
      { year: "2021", price: 2950000 }, { year: "2022", price: 3450000 },
      { year: "2023", price: 3720000 }, { year: "2024", price: 3900000 }, { year: "2025", price: 4180000 },
    ],
    drivers: [
      { stat: "+41%", text: "3-year appreciation across Park Shore waterfront" },
      { stat: "4.1 mo", text: "Months of supply — still a seller's market at this tier" },
    ],
  },
  comps: [
    { address: "22 Seagate Dr", beds: 5, baths: 6, sqft: 6040, status: "SOLD", price: 4200000, dom: "31 DOM", sold_date: "2025-09-12", distance_note: "0.4 mi away", narrative: "Closest match — same builder, sold 3% under ask after one price adjustment." },
    { address: "301 Neapolitan Way", beds: 5, baths: 5, sqft: 5680, status: "SOLD", price: 3850000, dom: "44 DOM", sold_date: "2025-07-28", distance_note: "0.6 mi away", narrative: "Smaller lot, no direct water view — sets the practical floor." },
    { address: "160 Colonade Cir", beds: 6, baths: 7, sqft: 6820, status: "SOLD", price: 4650000, dom: "22 DOM", sold_date: "2025-10-03", distance_note: "0.7 mi away", narrative: "Larger, fully furnished — establishes the ceiling for the submarket." },
    { address: "44 Southport Cove", beds: 5, baths: 6, sqft: 6210, status: "PENDING", price: 4375000, dom: "18 DOM", sold_date: "", distance_note: "0.5 mi away", narrative: "Nearly identical footprint — pending in under 3 weeks at $705/sqft." },
  ],
  pricing_logic: {
    title: "Why $4,295,000", recommended_price: 4295000,
    chart: [
      { label: "Low comp", price: 3850000 }, { label: "Median", price: 4200000 },
      { label: "Recommended", price: 4295000 }, { label: "High comp", price: 4650000 },
    ],
    reasons: [
      { title: "Anchored above the median comp", text: "The $4.2M closing at 22 Seagate had an older interior; this home's 2019 build and water view justify a premium." },
      { title: "Below the emotional ceiling", text: "Staying under $4.3M keeps the home in more search filters and preserves negotiating room." },
      { title: "Momentum-adjusted", text: "8.4% YoY $/sqft growth supports pricing at the top of the recent range." },
    ],
  },
  active_competition: [
    { address: "77 Bay Point", price: 4495000, beds: 5, baths: 6, sqft: 6300, status: "ACTIVE", dom_note: "52 DOM", narrative: "Overpriced and stale — makes this listing look sharply valued." },
    { address: "9 Tidewater Ln", price: 4100000, beds: 4, baths: 5, sqft: 5400, status: "ACTIVE", dom_note: "12 DOM", narrative: "Smaller — a value alternative but lacks the frontage." },
    { address: "215 Harbour Dr", price: 4600000, beds: 6, baths: 6, sqft: 6900, status: "ACTIVE", dom_note: "28 DOM", narrative: "Larger and pricier — reinforces our position as the better buy." },
  ],
  recommendation: {
    price: 4295000, price_low: 4150000, price_high: 4495000, likely_price: 4295000,
    price_per_sqft: 702, days_to_offer: "14–21 days", value_range: "$4,150,000 – $4,495,000",
    summary: "List at $4,295,000 to capture the top of the current comp range while staying beneath the psychological $4.3M ceiling. Expect a qualified offer inside three weeks given only 4.1 months of supply and a cash-heavy buyer pool.",
    how_we_hit: [
      "Launch with a cinematic media package and a coming-soon window to build a buyer list.",
      "Price at $4.295M — above the median comp, below the emotional ceiling.",
      "Hold firm through the first 14 days; the pending at 44 Southport supports the number.",
    ],
    risks: [
      "Rate shock could soften the sub-$4M tier, but this price band is largely cash.",
      "A furnished competitor at 160 Colonade may pull a fully-turnkey buyer.",
    ],
  },
  neighborhood: {
    name: "Park Shore", summary: "Naples' premier beachfront enclave — private beach access, the Venetian Village waterfront shops, and a boat-friendly bay all within a mile.",
    amenities: [
      { name: "Park Shore Beach", desc: "Private residents' Gulf beach access", distance: "0.5 mi" },
      { name: "Venetian Village", desc: "Waterfront dining & luxury retail", distance: "0.8 mi" },
      { name: "Waterside Shops", desc: "Saks, Nordstrom & fine dining", distance: "1.4 mi" },
    ],
    tailwinds: "Limited new-construction inventory and a fixed coastline keep Park Shore supply structurally tight.",
  },
  schools: {
    district: "Collier County Public Schools",
    list: [
      { name: "Sea Gate Elementary", grades: "K–5", distance: "0.9 mi", rating: "A", score: "9/10", desc: "Top-rated coastal elementary." },
      { name: "Gulfview Middle", grades: "6–8", distance: "2.1 mi", rating: "A", score: "8/10", desc: "Strong STEM and arts programs." },
      { name: "Naples High", grades: "9–12", distance: "2.6 mi", rating: "A-", score: "8/10", desc: "IB program, competitive athletics." },
    ],
    disclaimer: "Verify attendance zones before relying on assignments.",
  },
  lifestyle: {
    walk_score: 62, bike_score: 71, transit_score: 34,
    drive_times: [{ place: "Naples Pier", min: 8 }, { place: "RSW Airport", min: 42 }, { place: "5th Ave South", min: 10 }],
    destinations: ["Private beach", "Venetian Village", "Waterside Shops", "Downtown Naples"],
  },
  investment: {
    monthly_rent: "$28,000/mo (seasonal)", gross_yield: "7.9%", cap_rate: "4.8%", gross_annual: "$336,000",
    thesis: "Seasonal luxury rentals in Park Shore command premium weekly rates from December–April, supporting a strong gross yield for a second-home buyer.",
    disclaimer: "Estimates only — not investment advice.",
  },
  cta: {
    steps: [
      { title: "Approve the strategy", text: "Confirm the $4.295M launch price and go-to-market plan." },
      { title: "Capture the media", text: "Cinematic photo, video, drone & 360° tour to lead the market." },
      { title: "Go live & convert", text: "Coming-soon window, then list to a warmed buyer pool." },
    ],
  },
};
